import { createContext, FC, useContext, useState, useEffect } from "react";
import { UserContextProps } from "../../types/context";

type User = {
  name: string,
  email: string,
  token: string
}

const UserContext = createContext<{ user?: User, setUser: (user: User) => void }>({
  user: undefined,
  setUser: () => null
});

const UserContextProvider: FC<UserContextProps> = (props: UserContextProps) => {
  const [user, setUser] = useState<User>();

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error('Error parsing saved user:', error);
        localStorage.removeItem('user');
      }
    }
  }, []);

  const handleSetUser = (newUser: User) => {
    setUser(newUser);
    localStorage.setItem('user', JSON.stringify(newUser));
  };

  return (
    <UserContext.Provider value={{ user, setUser: handleSetUser }}>
      {props.children}
    </UserContext.Provider>
  )
}

const useUserContext = () => useContext(UserContext);

export {UserContextProvider, useUserContext};